module.exports = __webpack_public_path__ + "img/business_group.dfe34119.png";